module.exports = __webpack_public_path__ + "img/default_avatar.2a6c222b.jpg";